import { render } from "./App.vue?vue&type=template&id=472cff63&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "./node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "472cff63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('472cff63', __exports__)) {
    api.reload('472cff63', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=472cff63&ts=true", () => {
    api.rerender('472cff63', render)
  })

}


export default __exports__